// @ts-nocheck

import theme from '../styled-components/dark';

export const extractHexColor = (hexColor, which) => {
  if (hexColor.length === 7 && hexColor.charAt(0) === '#') {
    switch (which) {
      case 'r':
        return parseInt(hexColor.slice(1, 3), 16);
      case 'g':
        return parseInt(hexColor.slice(3, 5), 16);
      case 'b':
        return parseInt(hexColor.slice(5, 7), 16);
      default:
        return null;
    }
  }
};

const percentColors = [
  {
    percentRatio: 0.0,
    color: {
      r: extractHexColor(theme.PercentDistribution.step1, 'r'),
      g: extractHexColor(theme.PercentDistribution.step1, 'g'),
      b: extractHexColor(theme.PercentDistribution.step1, 'b'),
    },
  },
  {
    percentRatio: 0.5,
    color: {
      r: extractHexColor(theme.PercentDistribution.step2, 'r'),
      g: extractHexColor(theme.PercentDistribution.step2, 'g'),
      b: extractHexColor(theme.PercentDistribution.step2, 'b'),
    },
  },
  {
    percentRatio: 1.0,
    color: {
      r: extractHexColor(theme.PercentDistribution.step3, 'r'),
      g: extractHexColor(theme.PercentDistribution.step3, 'g'),
      b: extractHexColor(theme.PercentDistribution.step3, 'b'),
    },
  },
];

export const getRawColorFromPercentage = (percentRatio, colors = percentColors) => {
  for (let i = 1; i <= colors.length - 1; i++) {
    if (percentRatio <= colors[i].percentRatio) {
      const lower = colors[i - 1];
      const upper = colors[i];
      const range = upper.percentRatio - lower.percentRatio;
      const rangePct = (percentRatio - lower.percentRatio) / range;
      const percentLower = 1 - rangePct;
      const percentUpper = rangePct;
      const color = {
        r: Math.floor(lower.color.r * percentLower + upper.color.r * percentUpper),
        g: Math.floor(lower.color.g * percentLower + upper.color.g * percentUpper),
        b: Math.floor(lower.color.b * percentLower + upper.color.b * percentUpper),
      };
      return { r: color.r, g: color.g, b: color.b };
    }
  }
};

export const getColorFromPercentage = (percent, colors = percentColors) => {
  const rawColor = getRawColorFromPercentage(percent / 100, colors);
  if (rawColor) {
    const { r, g, b } = getRawColorFromPercentage(percent / 100, colors);
    return `rgb(${r}, ${g}, ${b})`;
  } else {
    return 'transparent';
  }
};

export const computeOptimalColorFromBackgroundHex = (backgroundHex) => {
  const r = parseInt(backgroundHex.slice(1, 3), 16);
  const g = parseInt(backgroundHex.slice(3, 5), 16);
  const b = parseInt(backgroundHex.slice(5, 7), 16);

  const rLum = Math.pow(r / 255, 2.2);
  const gLum = Math.pow(g / 255, 2.2);
  const bLum = Math.pow(b / 255, 2.2);

  const lum = rLum * 0.2126 + gLum * 0.7151 + bLum * 0.0722;

  return lum < 0.179 ? '#ffffff' : '#000000';
};

export const hexToHSL = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);

  const r = parseInt(result[1], 16) / 255;
  const g = parseInt(result[2], 16) / 255;
  const b = parseInt(result[3], 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);

  let h = 0;
  let s = 0;
  const l = (max + min) / 2;

  if (max === min) {
    s = 0;
    h = s;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

    if (max === r) {
      h = (g - b) / d + (g < b ? 6 : 0);
    }

    if (max === g) {
      h = (b - r) / d + 2;
    }

    if (max === b) {
      h = (r - g) / d + 4;
    }

    h /= 6;
  }

  return {
    h: h * 360,
    s: s * 100,
    l: l * 100,
  };
};

export const HSLToHex = (h, s, l) => {
  l /= 100;
  const a = (s * Math.min(l, 1 - l)) / 100;

  const f = (n) => {
    const k = (n + h / 30) % 12;
    const color = l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
    return Math.round(255 * color)
      .toString(16)
      .padStart(2, '0'); // convert to Hex and prefix "0" if needed
  };

  return `#${f(0)}${f(8)}${f(4)}`;
};

export default {
  getRawColorFromPercentage,
  getColorFromPercentage,
};
